'use client';

import { useConsentGatedInit } from '../hooks';

type BrandContentV2Props = {
    initializeWebcollage: () => void;
};

export const BrandContentV2 = ({ initializeWebcollage }: BrandContentV2Props) => {
    useConsentGatedInit({
        src: '//scontent.webcollage.net/api/v2/product-content',
        consentGroup: 'C0003',
        onReady: initializeWebcollage,
    });

    return null;
};
